import React, { useState, useEffect } from "react";
import { icons, FLAVOR } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import * as request from "../../services/FetchService";
import Button from "../Buttons/Button";
import { Collapse } from "@mui/material";
import ContactForm from "./ContactForm";
import { useIsMobile } from "../../helpers/customHooks";
import ShowLocationsModal from "../Modals/ShowLocationsModal";
import NewSupportTicketModal from "../Modals/NewSupportTicketModal";
import OpenSupportTicketModal from "../Modals/OpenSupportTicketModal";
import toast from "react-hot-toast";
import TicketPlaceholder from "../Placeholders/TicketPlaceholder";
import NewSupportMessageModal from "../Modals/NewSupportMessageModal";
import { fixDate } from "../../helpers/helperFunctions";

const Support = ({ isOpen, setIsOpen, outerType, setOuterType, ticketId, setTicketId }) => {
	const { i18n, t } = useTranslation();
	const MOBILE = useIsMobile();
	const [faqData, setFaqData] = useState();
	const [currFaq, setCurrFaq] = useState(-1);
	const [locations, setLocations] = useState([]);
	const [showLocationsList, setShowLocationsList] = useState(false);
	const [showSupportTicketView, setShowSupportTicketView] = useState(false);
	const [userLocation, setUserLocation] = useState({ lat: null, lng: null });
	const [showModal, setShowModal] = useState(false);
	const [clickedAddress, setClickedAddress] = useState("");
	const [externalLinksVisible, setExternalLinksVisible] = useState(false);
	const [showNewTicketModal, setShowNewTicketModal] = useState(false);
	const [showNewMessageModal, setShowNewMessageModal] = useState(false);
	const [showOpenTicketModal, setShowOpenTicketModal] = useState(false);
	const [tickets, setTickets] = useState([]);
	const [openTicketId, setOpenTicketId] = useState();
	const [loadingTickets, setLoadingTickets] = useState(true);
	const [supportCenterURL, setSupportCenterURL] = useState("");
	const [ticketType, setTicketType] = useState("");
	const [visibility, setVisibility] = useState({ faq: false, servicelocations: false, support: false, supportcenter: false });
	const [blocked, setBlocked] = useState(true);

	useEffect(() => {
		getSupportInfo();
		if (FLAVOR === "bike") {
			getServiceLocations();
		}
	}, []);

	useEffect(() => {
		if (ticketId) {
			handleTicket(ticketId);
		}
	}, [ticketId]);

	const handleTicket = (id) => {
		setOpenTicketId(id);
		setTicketId(null);
		// setShowOpenTicketModal(true)
		toast.loading(`${t("toast.opening_ticket")}...`, { id: "opening" });
	};

	const getTickets = () => {
		request.get("account/support/tickets/list").then((response) => {
			if (response?.data?.successful) {
				setLoadingTickets(false);
				setTickets(response?.data?.tickets);
			}
		});
	};

	useEffect(() => {
		// This function will be called whenever the language changes
		const onLanguageChanged = () => {
			getSupportInfo();
		};
		// Register the event listener for language changes
		i18n.on("languageChanged", onLanguageChanged);

		// Cleanup function to remove the event listener
		return () => {
			i18n.off("languageChanged", onLanguageChanged);
		};
	}, [i18n]); // Dependency array to ensure effect is set up correctly

	const getSupportInfo = () => {
		request.get("services/support/info").then((response) => {
			if (response?.data?.successful) {
				setFaqData(response?.data?.response?.faq?.data);
				setVisibility({
					...visibility,
					faq: response?.data?.response?.faq?.valid,
					servicelocations: response?.data?.response?.servicelocations?.valid,
					support: response?.data?.response?.support?.valid,
					supportcenter: response?.data?.response?.supportcenter?.valid,
				});
				setTicketType(response?.data?.response?.support?.type);
				setSupportCenterURL(response?.data?.response?.supportcenter?.url);
			}
		});
	};
	useEffect(() => {
		if (visibility.servicelocations && showLocationsList) {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition((position) => {
					setUserLocation({
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					});
				});
			} else {
				console.error("Get position failed");
			}
		}
	}, [visibility.servicelocations, showLocationsList]);

	const getServiceLocations = () => {
		request.get("services/locations").then((response) => {
			if (response?.data?.successful) {
				setLocations(response.data.servicelocations);
			}
		});
	};

	const openFaq = (index) => {
		if (currFaq === index) {
			setCurrFaq(-1);
		} else {
			setCurrFaq(index);
		}
	};
	const haversineDistance = (lat1, lon1, lat2, lon2) => {
		const R = 6371; // Radius of the Earth in km
		const dLat = (lat2 - lat1) * (Math.PI / 180);
		const dLon = (lon2 - lon1) * (Math.PI / 180);
		const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		const distance = R * c;
		return distance;
	};

	useEffect(() => {
		if (!showModal) {
			setClickedAddress();
		}
	}, [showModal]);

	const handleModal = (address) => {
		setClickedAddress(address);
		setShowModal(!showModal);
	};

	const openExternalLink = (url = "https://www.google.com") => {
		window.open(url, "_blank");
	};

	useEffect(() => {
		if (showSupportTicketView && !showNewTicketModal) {
			getTickets();
		}
	}, [showNewTicketModal, showSupportTicketView]);

	// useEffect(() => {
	//     setShowSupportTicketView(ticketOpen)
	// }, [ticketOpen])

	// useEffect(() => {
	//     setTicketOpen(showSupportTicketView)
	// }, [showSupportTicketView])

	useEffect(() => {
		if (!isOpen) {
			setShowSupportTicketView(null);
			setShowLocationsList(null);
		}
	}, [isOpen]);

	useEffect(() => {
		switch (outerType) {
			case "tickets":
				setShowSupportTicketView(true);
				return;
			case "service_locations":
				setShowLocationsList(true);
				return;
			default:
				setShowSupportTicketView(false);
				setShowLocationsList(false);
		}
	}, [outerType]);

	useEffect(() => {
		if (loadingTickets) return;
		if (!tickets || tickets.length === 0) {
			setBlocked(false);
			return;
		}

		const hasActiveTicket = tickets.some((ticket) => ticket.status === "open" || ticket.status === "solved");

		setBlocked(hasActiveTicket);
	}, [tickets, loadingTickets]);

	const mainView = () => {
		return (
			<>
				{/* CONTACT / SUPPORT TICKET */}
				<div className={`${visibility.support ? "mb-3" : "d-none"}`}>
					<p className="mb-1 bold">{t("settings.contact_us")}</p>
					<div onClick={() => (ticketType === "tickets" ? setOuterType("tickets") : setShowNewMessageModal(true))} className={`p-3 d-flex justify-content-between settings-radius align-items-center cursor-pointer bg-white`}>
						<h4 className="regular">{ticketType === "tickets" ? t("settings.support_tickets") : t("settings.support_message")}</h4>
						<img className="size_15 grey-blue-icon" src={icons.chevron_right} alt={""} />
					</div>
				</div>
				{/* SUPPORT CENTER */}
				<div className={`${visibility.supportcenter ? "mb-3" : "d-none"}`}>
					<p className="mb-1 bold">{t("settings.external_links")}</p>
					<div onClick={() => openExternalLink(supportCenterURL)} className={`p-3 d-flex justify-content-between settings-radius align-items-center cursor-pointer bg-white`}>
						<h4 className="regular">{t("settings.support_center")}</h4>
						<img className="size_15 grey-blue-icon" src={icons.external_link} alt={""} />
					</div>
				</div>
				{/* FAQ */}
				<div className={`${visibility.faq ? "mb-3" : "d-none"} d-flex flex-column`}>
					<p className="mb-1 bold">{t("settings.faq")}</p>
					{faqData &&
						faqData.map((faq, index) => (
							<div key={index} className={`d-flex flex-column settings-radius ${index !== faqData.length - 1 ? "mb-3" : ""}`}>
								<div className={`p-3 d-flex justify-content-between bg-white align-items-center cursor-pointer`} onClick={() => openFaq(index)}>
									<p className="body bold">{faq.titel}</p>
									<img className={`size_15 grey-blue-icon ${index === currFaq ? "rotate-0" : "rotate-180"}`} src={icons.chevron_down} alt={""} />
								</div>
								<Collapse in={index === currFaq} className="primary">
									<div className="bg-white px-3 pb-3">
										{faq.body_text.split("\n").map((text, index) => (
											<p className={`m-0 p-0 mb-1`} key={index}>
												{text}
											</p>
										))}
									</div>
								</Collapse>
							</div>
						))}
				</div>
				{/* SERVICE LOCATION */}
				<div className={`${visibility.servicelocations ? "mb-3" : "d-none"}`}>
					<p className="mb-1 bold">{t("settings.service_locations")}</p>
					<div onClick={() => setOuterType("service_locations")} className={`p-3 d-flex justify-content-between settings-radius align-items-center cursor-pointer bg-white`}>
						<h4 className="regular">{t("settings.find_service_locations")}</h4>
						<img className="size_15 grey-blue-icon" src={icons.chevron_right} alt={""} />
					</div>
				</div>
				{/* EXTERNAL LINKS */}
				<div className={`${externalLinksVisible ? "mb-3" : "d-none"}`}>
					<p className="mb-1 bold">{t("settings.external_links")}</p>
					<div onClick={() => openExternalLink()} className={`p-3 d-flex justify-content-between  settings-radius align-items-center cursor-pointer bg-white`}>
						<h4 className="regular">{t("settings.support")}</h4>
						<img className="size_15 grey-blue-icon" src={icons.chevron_right} alt={""} />
					</div>
				</div>
				{/* <ContactForm externalLinksVisible={externalLinksVisible} faqVisible={visibility.faq} /> */}
			</>
		);
	};

	const locationsListView = () => {
		const sortedLocations =
			userLocation?.lat && userLocation?.lng
				? [...locations].sort((a, b) => {
						const distA = haversineDistance(userLocation.lat, userLocation.lng, a.latitude, a.longitude);

						const distB = haversineDistance(userLocation.lat, userLocation.lng, b.latitude, b.longitude);

						return distA - distB;
					})
				: locations;

		return (
			<div className="mb-3">
				<p className="mb-1 bold">{t("settings.service_locations")}</p>
				<div className="d-flex flex-column settings-radius">
					{sortedLocations.map((item, index) => (
						<div key={index} className={`p-3 d-flex justify-content-between bg-white cursor-pointer ${index < sortedLocations.length - 1 ? "border-settings" : ""}`} onClick={() => handleModal(item.address)}>
							<div className="d-flex flex-column">
								<h4 className="bold">{item.name}</h4>
								<p>{item.address}</p>
							</div>
							<div className="d-flex flex-column align-items-center">
								<img className="size_25" src={icons.marker} alt="" />
								<p className={`${userLocation?.lat && userLocation?.lng ? "" : "d-none"}`}>{userLocation?.lat && userLocation?.lng ? `${haversineDistance(userLocation.lat, userLocation.lng, item.latitude, item.longitude).toFixed(0)} km` : null}</p>
							</div>
						</div>
					))}
				</div>
			</div>
		);
	};

	const supportTicketView = () => {
		return (
			<>
				<div className="">
					{/* {!MOBILE && <Button btnClass="btn-left-section" className="align-self-start" icon={icons.back} notext={true} onClick={() => setShowSupportTicketView(false)}/>} */}
					{!blocked && (
						<>
							<p className="mb-1 bold">{t("settings.contact_us")}</p>

							<div onClick={() => setShowNewTicketModal(true)} className={`p-3 d-flex justify-content-between settings-radius align-items-center cursor-pointer ${""} ${"bg-white"}`}>
								<h4 className="regular">{t("settings.start_ticket")}</h4>
								<img className="size_15 grey-blue-icon" src={icons.chevron_right} alt={""} />
							</div>
						</>
					)}

					<p className="mb-1 bold mt-3">{t("settings.previous_tickets")}</p>
					{tickets?.length === 0 && !loadingTickets && <h3 className="bold dark-grey text-center mt-5">{t("settings.no_tickets_found")}</h3>}
					<div className="d-flex flex-column settings-radius">
						{loadingTickets ? (
							<TicketPlaceholder />
						) : (
							tickets.map((item, index) => (
								<div key={index} className={`p-3 d-flex justify-content-between bg-white cursor-pointer ${index < tickets.length - 1 ? "border-settings" : ""}`} onClick={() => handleTicket(item.id)}>
									<div className="d-flex flex-column">
										<p className={`bold`}>{item.subject}</p>
										<div className="d-flex">
											<p className={`${item?.status === "closed" ? "red" : "green"}`}>{t(`settings.status_${item?.status === "closed" ? "closed" : "open"}`)}</p>
											<p className={`dark-grey ms-1`}>{`- ${item?.updated_at ? fixDate(item?.updated_at, true) : fixDate(item?.created_at)}`}</p>
										</div>
									</div>
									<img className="size_15 align-self-center grey-blue-icon" src={icons.chevron_right} alt={""} />
								</div>
							))
						)}
						{}
					</div>
				</div>
			</>
		);
	};

	return (
		<>
			{!showLocationsList && !showSupportTicketView && mainView()}
			{showLocationsList && locationsListView()}
			{showSupportTicketView && supportTicketView()}
			<ShowLocationsModal show={showModal} address={clickedAddress} onClose={() => setShowModal(!showModal)} />
			<NewSupportTicketModal show={showNewTicketModal} getTickets={getTickets} onClose={() => setShowNewTicketModal(!showNewTicketModal)} />
			<NewSupportMessageModal show={showNewMessageModal} onClose={() => setShowNewMessageModal(!showNewMessageModal)} />
			<OpenSupportTicketModal show={showOpenTicketModal} setShow={setShowOpenTicketModal} getTickets={getTickets} ticketId={openTicketId} setTicketId={setOpenTicketId} updateList={() => getTickets()} onClose={() => setShowOpenTicketModal(!showOpenTicketModal)} />
		</>
	);
};

export default Support;
